import React, { useEffect } from 'react'

import PropTypes from 'prop-types'

import {
  Redirect as ReactDomRedirect,
  Route as ReactDomRoute
} from 'react-router-dom'

import { useAuth } from '../hooks/auth'

/**
 *   Updates the selected/global module when a page witch belongs to a different module is accessed
 */
const RouteModuleManager = ({ name, component: Component }) => {
  const { unit, module, updateModule } = useAuth()

  useEffect(() => {
    const isAccessingDifferentModule = !module || module?.name !== name

    console.info('Accessing a different module:', isAccessingDifferentModule)

    if (isAccessingDifferentModule && unit) {
      const newModule = unit.modules.find(
        ({ name: unitModuleName }) => unitModuleName === name
      )

      console.info(
        `Update current module (${module?.name}) to:`,
        newModule?.name
      )

      if (newModule) updateModule(newModule)
    }
  }, [name, unit, module, updateModule])

  return <ReactDomRoute render={() => <Component />} />
}

const Route = ({ meta, component: Component, ...props }) => {
  const { user: isSigned, unit } = useAuth()

  const mustAuthenticate = meta.isPrivate && !isSigned

  if (mustAuthenticate) {
    return (
      <ReactDomRoute
        {...props}
        render={() => <ReactDomRedirect to={{ pathname: '/' }} />}
      />
    )
  }

  if (!meta.permissions && !meta.roles) {
    return (
      <RouteModuleManager
        {...props}
        name={meta.module.name}
        component={Component}
      />
    )
  }

  const unitModule = meta.module.global
    ? unit.modules.find(Boolean)
    : unit.modules.find(
      ({ name: unitModuleName }) => unitModuleName === meta.module.name
    )

  const hasRole = !meta.roles?.length || meta.roles?.some((role) => {
    return unit.module.role === role
  })

  const hasPermission = hasRole && meta.permissions?.every((rule) => {
    return unitModule?.permissions?.includes(rule)
  })

  if (isSigned && !hasPermission) {
    console.error(
      `The logged user has no permissions for '${meta.permissions}' in '${meta.module.name}' for the selected unit`
    )
    console.error(`User permissions for unit ${unit.name} `, unit.modules)
  }

  return (
    <ReactDomRoute
      {...props}
      render={() => {
        return hasPermission ? (
          <RouteModuleManager
            {...props}
            name={meta.module.name}
            component={Component}
          />
        ) : (
          <ReactDomRedirect to={{ pathname: '/403' }} />
        )
      }}
    />
  )
}

RouteModuleManager.propTypes = {
  name: PropTypes.string,
  component: PropTypes.isRequired
}

Route.defaultProps = {
  meta: {}
}

Route.propTypes = {
  ...ReactDomRoute.propTypes,
  meta: PropTypes.object,
  component: PropTypes.any.isRequired
}

export default Route
